/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react'
import styled from 'styled-components'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { node } from 'prop-types'
import pattern from '../../assets/imagens/pattern.png'
import Menu from '../Menu/Menu'
import ToastGeral from '../ToastGeral/ToastGeral'
import { useGlobal } from '../../contexts/GlobalContext'

const estiloAssociadoLogado = `
  background-color: ${StyleGuide.cores.cinza100};
  margin: 0 auto;

  &::after {
    background-image: url( ${pattern} );
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }
`

const ContainerWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 0;
  margin-top: 50px !important;

  ${( { isAssociadoLogado } ) => isAssociadoLogado && estiloAssociadoLogado}
`

const WrapperMenu = styled.div`
  ${( { shouldShowMenu } ) => shouldShowMenu && `width: 245px;`}
  @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    display: none;
  }
`

const WrapperRoutes = styled.div`
  width: 100%;

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding: 0 20px 20px;
  }

  @media (min-width: 770px) {
    padding: 0 25px 85px;
  }


  ${( { isAssociadoLogado } ) => !isAssociadoLogado
    ? 'margin: 0 auto;'
    : ` @media(min-width: ${StyleGuide.mediaQuery.smallpc}) {
      max-width: 955px;
      margin-left: 20px;
      height: 100%;
      width: 100%;
    }`}
`

const ConteudoWrapper = styled.div`
  display: flex;
  min-height: calc(100vh - 40px);
  justify-content: ${( { shouldShowMenu } ) => shouldShowMenu ? `flex-start` : `center`};
`

const Container = ( { children } ) => {
  const { isAssociadoLogado, toastGeralInfo, shouldShowMenu } = useGlobal()

  return (
    <ContainerWrapper
      isAssociadoLogado={ isAssociadoLogado }
    >
      <Fragment>
        <ConteudoWrapper
          shouldShowMenu={ shouldShowMenu }
        >
          { isAssociadoLogado
            ? (
              <WrapperMenu shouldShowMenu={ shouldShowMenu }>
                <Menu isMobile={ false } />
              </WrapperMenu>
            ) : null}

          <WrapperRoutes
            isAssociadoLogado={ isAssociadoLogado }
          >
            { Boolean( toastGeralInfo ) &&
              <ToastGeral
                fechar={ toastGeralInfo.fechar }
                mensagem={ toastGeralInfo.mensagem }
                show={ Boolean( toastGeralInfo ) }
                tipoToast={ toastGeralInfo.tipoToast }
              />}

            { children }
          </WrapperRoutes>
        </ConteudoWrapper>
      </Fragment>
    </ContainerWrapper>
  )
}

Container.propTypes = {
  'children': node.isRequired
}

export default Container
